module.exports = __webpack_public_path__ + "img/wxp1.8f2f9819.png";